"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const schema = {
    type: "object",
    properties: {
        frequencyRemaining: {
            type: "string",
            title: "Frequency Remaining",
        },
        startingFromWeekOf: { type: "number", format: "date", disablePast: true },
        notes: {
            type: "string",
            title: "Notes",
            maxLength: 3000,
        },
    },
    required: ["startingFromWeekOf", "frequencyRemaining"],
};
exports.default = schema;
